/* tslint:disable */
import { Component, OnInit } from '@angular/core';
import { AtlasSharedService } from "./atlas/atlas-shared.service";
import { LabsService } from './services/labs.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']

})
export class AppComponent implements OnInit {

    constructor(public atlasSharedService: AtlasSharedService, 
        private labsService: LabsService) {
    }

    ngOnInit() {
        this.labsService.getLabs().subscribe();

    }
}


